import { useLocalization } from '../../../localization'; // Added import
import AccountSelectList from '../components/AccountSelectList';

import { ReactComponent as Connections } from "../../../images/svg/connections.svg";

import { ReactComponent as Info } from "../../../images/svg/info.svg";
import {
  CBHeader
} from '../../core/components/cbd';

import SEO from '../../../components/SEO';

const AccountListPage = props => {
  const { t } = useLocalization(); // Added hook call
  return (
  <div className="cb-content-frame">
    <SEO title={t('accounts.dashboard_title')} /> {/* Localized */}
    <div className="cb-content-pane mobile_padding" >
    <CBHeader icon={<Connections></Connections>} label={t('accounts.accounts_header')} buttonLabel={t('common.help')} buttonIcon={<Info></Info>} buttonAction={e=> { 
        window.open('https://help.calendarbridge.com/doc/getting-started/connecting-microsoft-calendars/', "_blank")
      }}></CBHeader>
   
    <AccountSelectList {...props} />
    </div>
  </div>
)}; // Added missing closing brace

export default AccountListPage
